<template>
        <v-container>
        <div class="text-h4 mb-5 mt-5">IPs de confianza</div>
            <v-card :loading="loading">
                <v-card-title>
                    <v-text-field
                        v-model="buscar"
                        append-icon="mdi-file-search-outline"
                        label="Buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-card-title>
                <v-dialog v-model="dialogEditarIP" max-width="500px" persistent>
                    <v-card>
                    <v-card-title>Editar IP</v-card-title>
                    <v-card-text>
                        <v-row class="mt-2" dense>
                            <v-col cols="12">
                                <v-text-field label="IP" filled color="blue-grey lighten-2" v-model="ipEditar.ip" disabled/>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea label="Observaciones" filled color="blue-grey lighten-2" v-model="nuevaObservacion"/>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="error" @click="dialogEliminar = true" text>Eliminar</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn text @click="dialogEditarIP = false">Cancelar</v-btn>
                        <v-btn color="blue darken-1" text @click="edicionIP()" :disabled="this.$v.nuevaObservacion.$invalid">Aceptar</v-btn>
                    </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-data-table :headers="headers" :items="ipsConfianza" :search="buscar">
                    <template v-slot:item.acciones="{ item }">
                    <v-icon @click="prepararDialogEditar(item)">mdi-pencil</v-icon>
                  </template>
                </v-data-table>
            </v-card>
        </div>
        <v-speed-dial v-model="fab" fixed direction="top" :transition="transition" style="bottom: 37px; right: 30px;">
            <template v-slot:activator>
                <v-btn v-model="fab" color="accent" dark fab>
                    <v-icon v-if="fab">mdi-close</v-icon>
                    <v-icon v-else>mdi-plus</v-icon>
                </v-btn>
            </template>
            <v-btn fab dark small color="indigo" @click="dialogNuevaIP = true">
                <v-icon>mdi-ip-network-outline</v-icon>
            </v-btn>
        </v-speed-dial>
        <v-dialog v-model="dialogNuevaIP" max-width="500px" persistent>
            <v-card>
                <v-card-title>Añadir IP</v-card-title>
                <v-card-text>
                    <v-row class="mt-2" dense>
                        <v-col cols="12">
                            <v-text-field 
                                label="IP" 
                                filled 
                                color="blue-grey lighten-2" 
                                v-model="IPNueva"
                                @blur="$v.IPNueva.$touch()"
                                @input="$v.IPNueva.$touch()"
                                :error-messages="errorIP"/>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea label="Observaciones" filled color="blue-grey lighten-2" v-model="obserbacionNuevaIP"/>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="finCreacionIP()">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="creacionIP()" :disabled="this.$v.IPNueva.$invalid || this.$v.obserbacionNuevaIP.$invalid">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogEliminar" persistent max-width="380">
            <v-card>
                <v-card-title class="headline">¡Atención!</v-card-title>
                <v-card-text>¿Estás seguro de que quieres eliminar esta IP?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogEliminar = false">Cancelar</v-btn>
                    <v-btn color="error" text @click="eliminarIP()">Eliminar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import { mapActions } from 'vuex';
    import { required,  ipAddress } from 'vuelidate/lib/validators';
    import axios from 'axios';
    axios.defaults.withCredentials = true;
    axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    export default {
        name: 'IPsConfianza',
        data: () => ({
            fab: false,
            transition: 'slide-y-reverse-transition',
            ipsConfianza: [],
            fab: false,
            transition: 'slide-y-reverse-transition',
            buscar: '',
            headers: [
                {
                    text: 'IP',
                    align: 'start',
                    filterable: true,
                    sortable: true,
                    value: 'ip'
                },
                {
                    text: 'Observaciones',
                    filterable: true,
                    sortable: true,
                    value: 'observaciones',
                },
                { 
                    text: '',
                    filterable: false,  
                    sortable: false,
                    value: 'acciones'
                }
            ],
            loading: false,
            dialogEditarIP: false,
            ipEditar: {},
            nuevaObservacion: '',
            dialogNuevaIP: false,
            IPNueva: '',
            obserbacionNuevaIP: '',
            dialogEliminar: false
        }),
        validations: {
            IPNueva: { required, ipAddress },
            obserbacionNuevaIP: { required },
            nuevaObservacion: { required }
        },
        methods: {    
            ...mapActions(['setSnackbar']),
            prepararDialogEditar(ip){
                this.ipEditar = ip;
                this.nuevaObservacion= ip.observaciones;
                this.dialogEditarIP = true;
            },
            edicionIP(){
                axios.patch('/api/ipConfianza/'+ this.nuevaObservacion, this.ipEditar).then(response => {
                    this.ipsConfianza[this.ipsConfianza.indexOf(this.ipEditar)].observaciones = this.nuevaObservacion;
                    this.dialogEditarIP = false;
                    this.setSnackbar({
                        snackbar: true,
                        tipo: 'success',
                        mensaje: 'Datos actualizados correctamente'
                    });
                }).catch(error => { 
                    this.setSnackbar({
                        snackbar: true,
                        tipo: 'error',
                        mensaje: 'Error. No se han podido actualizar los datos'
                    }); 
                });
            },
            eliminarIP(){
                axios.delete('/api/ipConfianza/'+ this.ipEditar.id).then(response => {
                    this.ipsConfianza.splice(this.ipsConfianza.indexOf(this.ipEditar), 1);
                    this.dialogEliminar = false;
                    this.dialogEditarIP = false;
                    this.setSnackbar({
                        snackbar: true,
                        tipo: 'success',
                        mensaje: 'La IP ha sido eliminada correctamente'
                    });
                }).catch(error => { 
                    this.setSnackbar({
                        snackbar: true,
                        tipo: 'error',
                        mensaje: 'Error. La IP no se ha podido eliminar correctamente'
                    });
                });
            },
            creacionIP(){
                let nuevaIP = {
                    IP: this.IPNueva,
                    observacion: this.obserbacionNuevaIP
                };
                axios.post("/api/ipConfianza", nuevaIP).then(respuesta => {
                    axios.get("/api/ipConfianza").then(respuesta => {
                        this.ipsConfianza = respuesta.data;
                    }).catch(error =>{
                        this.setSnackbar({
                            snackbar: true,
                            tipo: 'error',
                            mensaje: 'No se han podido recuperar las IPs de confianza'
                        });
                    });
                    this.finCreacionIP();
                    this.setSnackbar({
                        snackbar: true,
                        tipo: 'success',
                        mensaje: 'La IP ha sido creada correctamente'
                    });
                }).catch( error => {
                    this.setSnackbar({
                        snackbar: true,
                        tipo: 'error',
                        mensaje: 'Error. La IP no se han podido crear correctamente'
                    });
                });
            },
            finCreacionIP(){
                this.dialogNuevaIP = false;
                this.IPNueva = '';
                this.obserbacionNuevaIP = '';
                this.$v.$reset();
            }
        },
        mounted() {
            this.loading = true;
            axios.get("/api/ipConfianza").then(respuesta => {
                this.loading = false;
                this.ipsConfianza = respuesta.data;
            }).catch(error =>{
                this.loading = false;
                this.setSnackbar({
                    snackbar: true,
                    tipo: 'error',
                    mensaje: 'No se han podido recuperar las IPs de confianza'
                });
            });
        },
        computed: {
            errorIP() {
                if (this.$v.IPNueva.$dirty){ //comprobación de si se ha hecho clic en el campo
                    if (!this.$v.IPNueva.$ipAddress && this.$v.IPNueva.$invalid){ //comprobación de si el campo no tiene format ip
                        return 'IP incorrecta';
                    }
                }
            },
        }
    }
</script>